import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {
  EmailRegisterDto, ManufacturerDto,
  Page,
  UserManageGroupDto,
  UserManageGroupSearchParams,
  UserOfficialDto
} from '../../generated-model/model';
import {environment} from '../../environments/environment';
import {IgnoreNullHttpParams} from '../shared/Ignore-null-http-params';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class UserRest {

  http = inject(HttpClient)

  searchGroup(params: IgnoreNullHttpParams) {
    return this.http.get<Page<UserManageGroupDto>>(`${environment.serverUrl}/api/user/search-group`, {params: params.toHttpParam()})
  }

  searchAllUser(params: IgnoreNullHttpParams) {
    return this.http.get<Page<UserManageGroupDto>>(`${environment.serverUrl}/api/user/search-all-user`, {params: params.toHttpParam()})
  }

  saveInviteUser(emailDto: EmailRegisterDto) {
    return this.http.post(`${environment.serverUrl}/api/user/invite-user`, emailDto)
  }

  enableOrDisableUser(user: UserManageGroupDto) {
    return this.http.put(`${environment.serverUrl}/api/user/enable`, user);
  }

  changeUserRole(user: UserManageGroupDto) {
    return this.http.put(`${environment.serverUrl}/api/user/change-role`, user);
  }
  editUser(user: UserManageGroupDto) {
    return this.http.put(`${environment.serverUrl}/api/user/edit-user`, user);
  }

  saveOfficialUser(user:UserOfficialDto){
    return this.http.post(`${environment.serverUrl}/api/user/save-official-user`,user)
  }

  searchOfficialUser(params: IgnoreNullHttpParams) {
    return this.http.get<Page<UserOfficialDto>>(`${environment.serverUrl}/api/user/search-official-user`,{params:params.toHttpParam()})
  }

  editUserOfficial(user:UserOfficialDto){
    return this.http.put(`${environment.serverUrl}/api/user/edit-official-user`,user)
  }

  searchSsoUser(params: IgnoreNullHttpParams) {
    return this.http.get<Page<UserOfficialDto>>(`${environment.serverUrl}/api/user/search-sso-user`,{params:params.toHttpParam()})
  }

  disableUserManufacturer(manufacturer:ManufacturerDto){
    return this.http.put(`${environment.serverUrl}/api/user/disable-user-from-manufacturer`,manufacturer)
  }

  updateLoginTime() :Observable<any>{
    return this.http.put(`${environment.serverUrl}/api/user/login-time`,{})
  }

  updateUserDataFromKeycloak() :Observable<any>{
    return this.http.put(`${environment.serverUrl}/api/user/update-user-from-keycloak`,{})
  }

  isUserEnable(ssoId:string){
    return this.http.get<boolean>(`${environment.serverUrl}/api/user/is-user-enable`,{params:IgnoreNullHttpParams.fromObject({ssoId:ssoId}).toHttpParam()})
  }
}
